export enum EsitoEnum {
  NON_PRESENTE = 'NON_PRESENTE',
  OK = 'OK',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  NON_PAGATO = 'NON_PAGATO'
}
